/**
 * Builder theme hook — syncs builderTheme state to document class
 */
import { useEffect } from 'react';
import { useBuilderStore } from '@/state/store';

export function useBuilderTheme() {
  const builderTheme = useBuilderStore((s) => s.builderTheme);

  useEffect(() => {
    if (builderTheme === 'light') {
      document.documentElement.classList.add('sb-light');
    } else {
      document.documentElement.classList.remove('sb-light');
    }
  }, [builderTheme]);
}
